<template>
  <div>
    <input
      type="text"
      :id="inputId"
      :title="inputTitle"
      :placeholder="inputPlacehodler"
      :value="value"
      @input="onInput($event.target.value)"
    />
    <label :for="inputId">{{ inputName }}</label>
  </div>
</template>

<script>
const isEmail = value => {
  // eslint-disable-next-line no-useless-escape
  const REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return REGEXP.test(String(value).toLowerCase());
};

export default {
  name: 'InputEmailPaid',
  props: {
    value: [Number, String],
    inputId: String,
    inputName: String,
    inputTitle: String,
    inputPlacehodler: String,
  },
  data() {
    return {
      isValid: true,
    };
  },
  methods: {
    onInput(value) {
      value = value.trim();

      this.isValid = isEmail(value);
      this.$emit('input', value);
    },
  },
};
</script>
